import _ from 'lodash'

import { TREND, POSITIVE, NEGATIVE } from '../../constants'

/**
 * Converts string to boolean.
 * higherIsBetter property of row from API is string not boolean so we have to convert it
 * @param {string} value Input string
 * @returns {boolean} Converted bool from input
 */
export const getHigherIsBetterAsBool = (value) => {
    if (value === 'false') return false

    return !!value
}

/**
 * Returns trend based on input value.
 * Trends are specified in TREND constant
 * @param {number} value Input number used to get trend
 * @param {boolean} flipped Flips returned arrow
 * @returns {string} Trend value
 */
export const getArrowTrend = (value, flipped) => {
    const inputValue = _.isNaN(value) || _.isNil(value) ? 0 : _.toNumber(value)

    if (inputValue < -50) return `${TREND.STEEP_DECREASE}${!flipped ? NEGATIVE : POSITIVE}`
    if (_.inRange(inputValue, -51, 0)) return `${TREND.DECREASE}${!flipped ? NEGATIVE : POSITIVE}`
    if (inputValue === 0) return TREND.STAGNATION
    if (_.inRange(inputValue, 0, 51)) return `${TREND.INCREASE}${!flipped ? POSITIVE : NEGATIVE}`
    if (inputValue > 50) return `${TREND.STEEP_INCREASE}${!flipped ? POSITIVE : NEGATIVE}`

    return TREND.STAGNATION
}

/**
 * Formats input number according to its value
 * @param {number} value Number to be formatted
 * @returns {string} Formatted number
 */
export const formatResultValue = (value) => {
    const inputValue = _.toNumber(value)

    if (inputValue === 0 || _.isNaN(value) || _.isNil(value)) return '0'
    if (value === Number.NEGATIVE_INFINITY) return '0'
    if (value === Number.POSITIVE_INFINITY) return '0'
    if (inputValue > 0) return `+${value}`

    return value.toString()
}
